import React from "react";
import { CheckIcon, ChevronRightIcon, InfoIcon, ThumbsUpIcon } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
type ProsConsProps = {
  id: string;
  eyebrow: string;
  title: string;
  intro?: string;
  benefits: string[];
  considerations: string[];
  background?: "white" | "soft";
};
export function ProsCons({
  id,
  eyebrow,
  title,
  intro,
  benefits,
  considerations,
  background = "white"
}: ProsConsProps) {
  return <section className={`${background === "soft" ? "bg-soft" : "bg-white"} py-8 lg:py-14`} aria-labelledby={id} data-id="element-230" data-mp="2pjtir41cuwe2">
      <div className="mx-auto max-w-[1320px] px-5 lg:px-10" data-id="element-231" data-mp="2lldl867ne5me">
        <SectionHeading id={id} eyebrow={eyebrow} title={title} intro={intro} data-id="element-232" data-mp="2gqzvajbr8qp4" />
        <div className="mt-10 grid gap-6 lg:grid-cols-2" data-id="element-233" data-mp="2btzq0amqbrz2">
          <div className="flex h-full flex-col rounded-lg border border-line bg-white p-7 sm:p-9" data-id="element-234" data-mp="2brdho8s0l8fs">
            <h3 className="flex items-center gap-3 text-xl font-bold" data-id="element-235" data-mp="39aev7xw4pots">
              <ThumbsUpIcon className="h-5 w-5 text-rinnai" aria-hidden="true" data-id="element-236" data-mp="34gkhdb37g42m" /> Benefits
            </h3>
            <ul className="mt-6 grid gap-4" data-id="element-237" data-mp="m43njmf5yyqt">
              {benefits.map(benefit => <li key={benefit} className="flex gap-3 text-sm leading-6 text-muted" data-id="element-238" data-mp="r1n3qrvf9lle">
                  <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-rinnai" aria-hidden="true" data-id="element-239" data-mp="da8gu9ye9092" />
                  {benefit}
                </li>)}
            </ul>
          </div>
          <div className="flex h-full flex-col rounded-lg border border-line bg-white p-7 sm:p-9" data-id="element-240" data-mp="3c2j84jmega0">
            <h3 className="flex items-center gap-3 text-xl font-bold" data-id="element-241" data-mp="8cq9go00yt36">
              <InfoIcon className="h-5 w-5 text-ink" aria-hidden="true" data-id="element-242" data-mp="3qi1u68di0oih" /> Worth knowing
            </h3>
            <ul className="mt-6 grid gap-4" data-id="element-243" data-mp="3uide1iy1eksw">
              {considerations.map(consideration => <li key={consideration} className="flex gap-3 text-sm leading-6 text-muted" data-id="element-244" data-mp="1opx99guf2rh9">
                  <ChevronRightIcon className="mt-1 h-4 w-4 shrink-0 text-ink" aria-hidden="true" data-id="element-245" data-mp="1ssa95omhfv64" />
                  {consideration}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}